<template>
    <div class="base-section">

        <div class="base-section__body">
            <div class="base-section__title-wrapper">
                <h3 class="base-section__title">{{ title }}</h3>
            </div>

            <div class="base-section__main">
                <slot />
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.base-section {

    &__body {
        width: 80%;
        text-align: center;
        margin: 0 auto;
    }

    &__title-wrapper {
        text-align: left;
        border-bottom: 1px solid #e0e1e2;
    }

    &__title {
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
    }

    &__main {
        margin: 20px 0;
    }
}
</style>